import useApi from '../api';

export interface UptimeData {
  playerId: number;
  playerName: string;
  dateStarted: number;
  dateEnded: number;
  uptimeSeconds: number;
  status: 'online' | 'offline';
}

export async function getPlayerUptimes(
  startDate: string,
  endDate: string
): Promise<UptimeData[]> {
  const { get } = useApi();
  
  const { responseBody } = await get('Api/Players/Uptimes', {
    params: {
      startDate,
      endDate
    },
    isLogoutOnInvalidAuth: true
  });
  
  return responseBody;
} 